import { render, staticRenderFns } from "./OrgUnitSelector.vue?vue&type=template&id=dbe986ea&scoped=true&lang=html&"
import script from "./OrgUnitSelector.vue?vue&type=script&lang=js&"
export * from "./OrgUnitSelector.vue?vue&type=script&lang=js&"
import style0 from "./OrgUnitSelector.vue?vue&type=style&index=0&id=dbe986ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe986ea",
  null
  
)

export default component.exports